import type { CSSProperties } from 'react';
import { cx } from '../utils/classnames';

export type TileState = 'correct' | 'present' | 'absent';

interface TileProps {
  letter?: string;
  state?: TileState;
  filled?: boolean;
  reveal?: boolean;
  /** Stagger index for the reveal flip. */
  index?: number;
  size?: 'sm' | 'md' | 'lg';
  ariaHidden?: boolean;
}

export function Tile({ letter, state, filled, reveal, index = 0, size, ariaHidden }: TileProps) {
  return (
    <div
      className={cx('cv-tile', size && `cv-tile--${size}`, reveal && 'cv-tile--reveal')}
      data-state={state}
      data-filled={filled ? 'true' : undefined}
      style={reveal ? ({ '--i': index } as CSSProperties) : undefined}
      aria-hidden={ariaHidden ? true : undefined}
    >
      {letter ? letter.toUpperCase() : ''}
    </div>
  );
}
